import { Component, Input, OnInit, ViewChildren } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { UtilsService } from '@ascschool/services/utils.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { LopHocNienHoc } from '@ascschool/model/category/lop-hoc-nien-hoc.model';
import { ClassCourseCourseService } from '@ascschool/services/category/class-course.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SchoolLevelService } from '@ascschool/services/school/school-level.service';
import { SchoolService } from '@ascschool/services/organization/school.service';
import { CourseService } from '@ascschool/services/school/course.service';
import { StaffService } from '@ascschool/services/user/staff.service';

@Component({
  selector: 'app-chinh-sua-lop-hoc-nien-hoc',
  templateUrl: './chinh-sua-lop-hoc-nien-hoc.component.html',
  styleUrls: ['./chinh-sua-lop-hoc-nien-hoc.component.scss']
})
export class ChinhSuaLopHocNienHocComponent implements OnInit {
  @ViewChildren("label") labelElement;
  @Input() dataTransmission: any;
  @Input() cosoId: number;
  @Input() provinceId: number;
  isEditMode = false;
  resultQT = '';
  resultSL = '';
  currentUser: any;
  sl: number = 0;
  lophocnienhoc = new LopHocNienHoc();
  errorMsg: string;
  isDisabled = false;
  validateForm!: FormGroup;
  getSchoolACFn: (value: any) => Observable<any>;
  SchoolSubscription: any;
  SchoolControl = new FormControl();
  getCourseACFn: (value: any) => Observable<any>;
  CourseSubscription: any;
  CourseControl = new FormControl();

  getSchoolLevelACFn: (value: any) => Observable<any>;
  SchoolLevelSubscription: any;
  SchoolLevelControl = new FormControl();

  getGiaoVienChuNhiemACFn: (value: any) => Observable<any>;
  GiaoVienChuNhiemSubscription: any;
  GiaoVienChuNhiemControl = new FormControl();
  constructor(
    private modal: NzModalRef,
    public utilsService: UtilsService,
    private schoolService: SchoolService,
    private schoolLevelService: SchoolLevelService,
    private courseService: CourseService,
    private staffService : StaffService,
    private service: ClassCourseCourseService,
  ) {
    
  }
  ngOnInit() {
    this.lophocnienhoc.courseId = JSON.parse(localStorage.getItem('nienhochientai'));
    this.currentUser = JSON.parse(localStorage.getItem('userSetting'));
    if(this.lophocnienhoc.courseId && this.cosoId){
      this.courseService.getEspCoursesById(this.lophocnienhoc.courseId).subscribe(res =>{
        this.CourseControl.setValue({id : res.id , text : res.courseName})
      });
      this.schoolService.GetSelectPagingById(this.cosoId).subscribe(res =>{
        this.SchoolControl.setValue({id : res.id , text: res.educationAndTrainingName})
      });
    }
    if (this.dataTransmission && this.dataTransmission.id > 0) {
      this.GetById(this.dataTransmission.id);
      this.isEditMode = true;
    } else {
      this.lophocnienhoc = new LopHocNienHoc();
      this.isEditMode = false;
    }
    if(this.currentUser.accountType === 3){
      this.loadSchool();
    }else{
      this.loadSchoolNoProvinceId();
    }
    this.loadCourse(); 
    this.loadGiaoVienChuNhiem();
  }
  loadSchoolNoProvinceId() {
    this.getSchoolACFn = (value: any) => this.schoolService.getSelectPaging({searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.educationAndTrainingName })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.SchoolSubscription) this.SchoolSubscription = this.SchoolControl.valueChanges.subscribe(() => {
      this.utilsService.bindOrUnBindTheId(this.lophocnienhoc, 'schoolId', this.SchoolControl.value);
    });
  }
  loadSchool() {
    this.getSchoolACFn = (value: any) => this.schoolService.getSelectPagingForStaff({ searchTerm: value, PageIndex: 1, PageSize: 100, ProvinceId: this.provinceId, SubordinateTypeId: 0  }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.educationAndTrainingName })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.SchoolSubscription) this.SchoolSubscription = this.SchoolControl.valueChanges.subscribe(() => {
      this.utilsService.bindOrUnBindTheId(this.lophocnienhoc, 'schoolId', this.SchoolControl.value);
    });
  }

  changeSchool(control: FormControl) {
    this.SchoolControl = control; 
    if(this.SchoolControl.value){
      
    }
  }

  loadCourse() {
    this.getCourseACFn = (value: any) => this.courseService.getEspCoursesSelectPaging({searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.courseName })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.CourseSubscription) this.CourseSubscription = this.CourseControl.valueChanges.subscribe(() => {
      this.utilsService.bindOrUnBindTheId(this.lophocnienhoc, 'courseId', this.CourseControl.value);
    });
  }
changeCourse(control: FormControl) {
    this.CourseControl = control;  
    if(this.CourseControl.value){
    }
  }

  loadSchoolLevel() {
    this.getSchoolLevelACFn = (value: any) => this.schoolLevelService.getSchoolLevelsSelectPaging({searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.schoolLevelName })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.SchoolLevelSubscription) this.SchoolLevelSubscription = this.SchoolLevelControl.valueChanges.subscribe(() => {
      this.utilsService.bindOrUnBindTheId(this.lophocnienhoc, 'schoolLevelId', this.SchoolLevelControl.value);
    });
  }
changeSchoolLevel(control: FormControl) {
    this.SchoolLevelControl = control;   
  }

  loadGiaoVienChuNhiem() {
    this.getGiaoVienChuNhiemACFn = (value: any) => this.staffService.GetSelectPagingTheoQuyen({searchTerm: value,SchoolId:this.cosoId,  PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.fullName })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.GiaoVienChuNhiemSubscription) this.GiaoVienChuNhiemSubscription = this.GiaoVienChuNhiemControl.valueChanges.subscribe(() => {
      this.utilsService.bindOrUnBindTheId(this.lophocnienhoc, 'managerId', this.GiaoVienChuNhiemControl.value);
    });
  }
  changeGiaoVienChuNhiem(control: FormControl) {
    this.GiaoVienChuNhiemControl = control;   
  }
  GetById(id : number){
    this.service.getClassCourseById(id).subscribe((res : any)=>{
      this.lophocnienhoc = res;
      this.schoolService.GetSelectPagingById(this.lophocnienhoc.schoolId).subscribe(response =>{
        this.provinceId = response.provinceId;
        this.SchoolControl.setValue({id : response.id , text : response.educationAndTrainingName});
      });
      this.courseService.GetSelectPagingById(this.lophocnienhoc.courseId).subscribe(response =>{
        this.CourseControl.setValue({id : response.id , text:response.courseName});
      });
      if(this.lophocnienhoc.managerId){ 
        this.staffService.getById(this.lophocnienhoc.managerId).subscribe(res =>{
          this.GiaoVienChuNhiemControl.setValue({id : res.id , text: res.fullName})
        });
      }
    });
  }
  close() {
    this.destroyModal();
  }
  destroyModal(): void {
    this.modal.destroy(true);
  }
  UpdateClose(){
    if(this.lophocnienhoc.schoolId && this.lophocnienhoc.className){ 
      this.service.addOrUpdateClassCourse(this.lophocnienhoc).subscribe((res)=>{
        if(res.statusCode == 0){
          this.utilsService.notifyResponse(res);
          this.close();
        }else{
          this.utilsService.notifyResponse(res);
        }
      }) 
    }else{
      this.utilsService.notifyValidateNgModel(this.lophocnienhoc,this.labelElement);
    } 
   
  }
   
  addQuyTac(text: string) {
    this.resultQT = text.toUpperCase();
  }

  addSoLuong(sl) {
    this.sl = sl
  }
}
